import {
  CANCELLATION_REASON_OTHER,
  type CancellationReason,
} from './cancellationReasons';

/** Salesforce ServiceAppointment.CancellationReason field limit (TEXT 255). */
export const SALESFORCE_CANCELLATION_REASON_MAX_LENGTH = 255;

export const CANCELLATION_REASON_OTHER_PREFIX = 'Other: ';

/** Max characters the member can enter for the Other comment before prefix is applied. */
export const CANCELLATION_REASON_OTHER_COMMENT_MAX_LENGTH =
  SALESFORCE_CANCELLATION_REASON_MAX_LENGTH -
  CANCELLATION_REASON_OTHER_PREFIX.length;

export const truncateToSalesforceCancellationReason = (
  value: string,
): string => {
  const trimmedValue = value.trim();

  return trimmedValue.length > SALESFORCE_CANCELLATION_REASON_MAX_LENGTH
    ? trimmedValue.slice(0, SALESFORCE_CANCELLATION_REASON_MAX_LENGTH)
    : trimmedValue;
};

export const isOtherCommentWithinSalesforceLimit = (
  otherComment: string,
): boolean =>
  otherComment.length <= CANCELLATION_REASON_OTHER_COMMENT_MAX_LENGTH;

export const isCancelAppointmentPayloadValid = (
  selectedReason: CancellationReason | null,
  otherComment: string,
): boolean => {
  if (!selectedReason) {
    return false;
  }

  if (selectedReason !== CANCELLATION_REASON_OTHER) {
    return true;
  }

  return isOtherCommentWithinSalesforceLimit(otherComment);
};
